import { render } from "./ParentClientListingDrawer.vue?vue&type=template&id=24912615&scoped=true"
import script from "./ParentClientListingDrawer.vue?vue&type=script&lang=js"
export * from "./ParentClientListingDrawer.vue?vue&type=script&lang=js"

import "./ParentClientListingDrawer.vue?vue&type=style&index=0&id=24912615&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24912615"]])

export default __exports__